module.exports = __webpack_public_path__ + "calendar.svg?dcabf46e5708b7fd573d55c9b9ca6046";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/calendar.svg
// module id = 24
// module chunks = 0